<div style="border: 1px dashed">
  <app-layout-container fluid>
    <app-layout-row>
      <app-layout-column [width]="4">
        <span>Two-way binding</span>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="4" offset="4">
        <!-- <app-textbox decorator [(ngModel)]="myData.name" caption="Name" infoText="Your full name"></app-textbox> -->
        <app-textbox decorator [(value)]="myData.name" caption="Name" infoText="Your full name"></app-textbox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="4" offset="4">
        <app-textbox decorator [(value)]="myData.email" caption="Email"></app-textbox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="1" offset="4">
        <app-textbox decorator [(value)]="myData.zip" caption="Zip"></app-textbox>
      </app-layout-column>
      <app-layout-column [width]="3">
        <app-textbox decorator [(value)]="myData.city" caption="City"></app-textbox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="2" offset="4">
        <app-password decorator [(value)]="myData.passwordHash" caption="Password (Hashed)" section="twoWayHash" mode="hash" infoText="This is a hash based password"></app-password>
      </app-layout-column>
      <app-layout-column [width]="2">
        <app-password decorator [(value)]="myData.passwordSecret" caption="Password (Secret)" section="twoWaySecret" mode="secret" infoText="This is a secret based password"></app-password>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="4" offset="4">
        <app-xpath decorator [(value)]="myData.xpath" caption="XPath" required maxlength="20" infoText="What' you think?"></app-xpath>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="2" offset="4">
        <app-singleselectbox decorator caption="Background color" infoText="Please pick a color" [(value)]="myData.backgroundColor" [dataSource]="colors()" valueExpr="id"
          displayExpr="name"></app-singleselectbox>
      </app-layout-column>
      <app-layout-column [width]="2">
        <app-singleselectbox decorator caption="Foreground color" infoText="Please pick a color" [(value)]="myData.foregroundColor" [dataSource]="colors()" valueExpr="id"
          displayExpr="name"></app-singleselectbox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="2" offset="4">
        <app-multiselectbox decorator caption="More colors" infoText="Please pick some colors" [(value)]="myData.moreColors" [dataSource]="colors()" valueExpr="id" displayExpr="name"></app-multiselectbox>
      </app-layout-column>
      <app-layout-column [width]="2">
        <app-multiselectbox decorator caption="Other colors" infoText="Please pick some colors" [(value)]="myData.otherColors" [dataSource]="colors()" valueExpr="id" displayExpr="name"></app-multiselectbox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="2" offset="4">
        <app-checkbox decorator="right-side" caption="Receive newsletter" [(value)]="myData.receiveNewsletter"></app-checkbox>
      </app-layout-column>
      <app-layout-column [width]="2">
        <app-datetimebox decorator datetime [(value)]="myData.datetime" caption="Date and time" minDate="2024-05-01T08:00:00+02:00" maxDate="2024-05-15T16:30:00+02:00"
          infoText="Specify a date and a time"></app-datetimebox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="2" offset="4">
        <app-datetimebox decorator date [(value)]="myData.date" caption="Date" minDate="2024-05-01" infoText="Specify just a date and no time"></app-datetimebox>
      </app-layout-column>
      <app-layout-column [width]="2">
        <app-datetimebox decorator time [(value)]="myData.time" caption="Time" [timeInterval]="10" infoText="Specify just a time and no date"></app-datetimebox>
      </app-layout-column>
    </app-layout-row>

    <app-layout-row>
      <app-layout-column [width]="4" offset="4">
        <div>Data: {{ myData | json }}</div>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="2" offset="6">
        <app-button secondary width="100%" (buttonClick)="refresh()">Reload</app-button>
      </app-layout-column>
    </app-layout-row>
  </app-layout-container>
</div>
